import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './global.less';  // 全局样式
ReactDOM.render(<App />, document.getElementById('root'));